export const getUserOrgId = async (
  getClaim: (keyName: string) => Promise<{
    value: string;
  } | null>,
  userOrgId: string | undefined
) => {
  const kindeTokenOrgId = (await getClaim("external_org_id"))?.value;
  return kindeTokenOrgId === "inrange.io" ? userOrgId : undefined;
};
